<!-- 采销订单管理 -->
<template>
  <div class="leasecontract" ref="tableWrapper">
    <div class="whole_contract_from">
      <el-form ref="from_params" :model="params">
        <QS-search>
          <el-form-item label="企业租赁订单ID" prop="id">
            <el-input
              v-model="params.id"
              placeholder="请输入企业租赁订单ID"
              clearable
              v-number:integer
            />
          </el-form-item>
          <el-form-item label="客户" prop="customerId">
            <el-select
              v-model="params.customerId"
              filterable
              clearable
              remote
              :remote-method="getCustomerList"
              placeholder="请输入客户名称搜索"
            >
              <el-option
                v-for="item in carProviderList"
                :key="item.id"
                :label="item.customerName"
                :value="item.id"
              >
                <CustomerNameOptionItem :data="item" />
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="订单创建时间" prop="startTime">
            <el-date-picker
              v-model="params.startTime"
              type="daterange"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
              start-placeholder="开始日期"
              range-separator="至"
              end-placeholder="结束日期"
              prefix-icon="el-icon-date"
              clearable
            />
          </el-form-item>

          <el-form-item label="所属部门" prop="deptIdList">
            <DeptSelect
              ref="deptSelectRef"
              v-model="params.deptIdList"
              :multiple="true"
              :isAll="false"
            />
          </el-form-item>

          <!-- 按钮区域-->
          <template slot="moreBtn">
            <el-form-item>
              <el-button
                type="primary"
                size="small"
                class="whole_contract_btn"
                @click="getsearch"
                :loading="BLMloading"
              >
                查询
              </el-button>
            </el-form-item>
            <el-form-item>
              <el-button
                size="small"
                class="whole_contract_btn"
                @click="getreset"
              >
                重置
              </el-button>
            </el-form-item>
            <el-form-item>
              <PublicExport
                v-if="judgePermission('workbench_ent_rent_order_main_export')"
                exportTitle="企业租赁订单导出"
                exportTemplate="LeaseOrder"
                :getSearchData="getCollect"
                templateCode="vehicle-workbench-ent-rent-order"
                :getSearchCondition="getSearchCondition"
              />
            </el-form-item>
          </template>
        </QS-search>
      </el-form>
    </div>
    <!-- 开始------------------>
    <div class="leasecontract_signing">
      <el-button
        v-if="judgePermission('workbench_ent_rent_order_main_add')"
        type="primary"
        size="small"
        class="whole_contract_btn"
        @click="addSigning"
      >
        企业签约提车
      </el-button>
      <el-button
        v-if="judgePermission('workbench_ent_rent_order_main_import')"
        type="primary"
        size="small"
        @click="initOrder"
      >
        初始化历史企业租赁订单
      </el-button>
    </div>
    <!-- 结束------------------>
    <!-- 开始---表格分页配套 -->
    <QS-common-table
      :data="tableData"
      :columns="headColumn"
      :pagination="paginationData"
      :loading="BLMloading"
      :height="tableHeight"
      @change="pageEvent"
    >
    </QS-common-table>
    <dialog-wrap-upgrade
      ref="batchImport"
      :configOptions="configOptions"
      @close="closeBox"
    >
      <template #uploadMain>
        <el-upload
          class="upload-demo"
          action=""
          :http-request="({ file }) => uploadRequest(file, 37)"
          :limit="1"
          :autoUpload="true"
          :file-list="fileList"
          :show-file-list="false"
          accept=".xls,.xlsx"
        >
          <el-button size="small" type="primary">初始化主订单</el-button>
        </el-upload>
      </template>
      <template #uploadVice>
        <el-upload
          class="upload-demo"
          action=""
          :http-request="({ file }) => uploadRequest(file, 38)"
          :limit="1"
          :autoUpload="true"
          :file-list="fileList"
          :show-file-list="false"
          accept=".xls,.xlsx"
        >
          <el-button size="small" type="primary">初始化在租子订单</el-button>
        </el-upload>
      </template>
      <template #uploadReturn>
        <el-upload
          class="upload-demo"
          action=""
          :http-request="({ file }) => uploadRequest(file, 39)"
          :limit="1"
          :autoUpload="true"
          :file-list="fileList"
          :show-file-list="false"
          accept=".xls,.xlsx"
        >
          <el-button size="small" type="primary">初始化已退子订单</el-button>
        </el-upload>
      </template>
    </dialog-wrap-upgrade>
  </div>
</template>

<script>
import { searchByCustomerName } from '@/api/domain/customers'
import { getLeaseOrderList, closeEnterpriseOrder } from '@/api/domain/orders'
import { debounce, getHead } from '@/utils'
import axios from 'axios'
import CustomerNameOptionItem from '@/components/CustomerSelect/optionItem'
import { entLeaseOrderTemplate, entLeaseSubOrderTemplate, entLeaseReutrnSubOrderTemplate } from '@/config'
import { uploadTaskCreate } from '@/api/currencyApi.js'
import { operateMaxShowLength } from '@/store/dict/config'
import { generateExportCondition } from '@/utils/exportUtils.js'


export default {
  name: 'primaryOrder',
  components: {
    CustomerNameOptionItem,
  },
  data() {
    return {
      orderState: {
        1: '已创建',
        2: '进行中',
        3: '已关闭',
      },
      // 客户列表
      carProviderList: [],
      BLMloading: false,
      // from表单内容
      params: {
        id: '', // 企业租赁订单ID
        customerId: '', // 客户
        startTime: [], // 开始时间
        endTime: '', // 结束时间
        state: '',
        deptIdList: [], // 所属部门
      },
      // 表格总数据
      total: 0,
      // 表格请求的总数据
      tableData: [],
      // 列表信息表头
      headColumn: [
        {
          name: 'id',
          columnProps: {
            label: '订单ID',
            prop: 'id',
            width: 100,
          },
          render: ({ row }) => {
            return (
              (this.judgePermission('workbench_ent_rent_order_main_detail') && (<span onClick={() => this.handleOrderIdClick(row.id)} class="processing hand cursor-point">{row.id}</span>)) || <span> {row.id}</span>
            )
          },
        },
        {
          name: 'carTotalNum',
          columnProps: {
            label: '租赁车辆数',
            prop: 'carTotalNum',
            width: 100,

          },
        },
        {
          name: 'rentedCarNum',
          columnProps: {
            label: '已租车辆数',
            prop: 'rentedCarNum',
            width: 100,

          },
        },
        {
          name: 'returnCarNum',
          columnProps: {
            label: '订单退车数',
            prop: 'returnCarNum',
            width: 100,
          },
        },
        {
          name: 'customerName',
          columnProps: {
            label: '客户名称',
            prop: 'customerName',
            width: 110,
          },
        },
        {
          name: 'createTime',
          columnProps: {
            label: '订单创建时间',
            prop: 'createTime',
            width: '180',
          },
        },
        {
          name: 'contractStartDate',
          columnProps: {
            label: '合同开始时间',
            prop: 'contractStartDate',
            width: 100,
          },
        },
        {
          name: 'contractEndDate',
          columnProps: {
            label: '合同结束时间',
            prop: 'contractEndDate',
            width: 100,
          },
        },
        {
          name: 'state',
          columnProps: {
            label: '订单状态',
            prop: 'state',
          },
          getText: ({ row }) => this.orderState[row.state],
        },
        {
          name: 'createUserName',
          columnProps: {
            label: '订单创建人',
            prop: 'createUserName',
            width: 110,
          },
        },
        {
          name: 'deptName',
          columnProps: {
            label: '所属部门',
            prop: 'deptName',
          },
        },
        {
          name: 'operate',
          columnProps: {
            label: '操作',
            fixed: 'right',
            width: 240,
          },
          maxShowLength: operateMaxShowLength,
          type: 'operate',
          getOperateList: ({ row }) => {
            const result = []
            if (this.judgePermission('workbench_ent_rent_order_main_add_car') && row.state === 2) {
              result.push({ name: 'addRentOrder', label: '订单续约', action: () => this.handlerRecallClick(row) })
            }
            if ((this.judgePermission('workbench_ent_rent_order_main_add_car') && row.state === 1) || row.state === 2) {
              result.push({ name: 'addRentOrder', label: '新增租赁车辆', action: () => this.handleAddCarClick(row) })
            }
            if (row.state !== 3 && this.judgePermission('workbench_ent_rent_order_main_close')) {
              result.push({ name: 'close', label: '关闭订单', action: () => this.getVoidComplete(row) })
            }
            return result
          },
        },
      ],
      pageSize: 10,
      pageNum: 1,
      // 标签类型
      state: null, // 1待确认/2进行中/3已完成/4已关闭
      dueState: null, // 1-30天内到期/2-已过期
      fileList: [],
      uploadCode: {
        37: 'order_renting_master_file',
        38: 'order_renting_son_file',
        39: 'order_renting_son_file',
      },
      tableHeight: 0,
      // c_personalTabsList有引用
      // eslint-disable-next-line vue/no-unused-properties
      customerConditionList: [],
    }
  },
  watch: {
    'params.customerId': {
      handler() {
        this.customerConditionList = this.carProviderList
      },
    },
  },
  computed: {
    // 导入功能弹框配置信息
    configOptions() {
      return {
        attrs: {
          title: '初始化历史企业租赁订单',
          width: '1000px',
          // closeOnClickModal: false
        },
        contentConfig: {
          title:
            '此功能用于批量初始化历史「企业租赁订单-主订单」和「企业租赁订单-子订单」这个功能的前提是，您已经制作了一张目标表单希望直接将Excel转移到系统，请单击 下载模版 下载Excel标准模板。',
          describes: [
            '导入前准备：',
            '1.请使用标准模版，确认未进行过任何更改，若无意中修改了模版的原有内容，建议重新下载模版；',
            '2.确保Excel中数据没有任何颜色样式，否则将与导入功能的错误提示混淆；',
            '3.确保excel中数据格式正确。',
            '4.如果表单中有设置必填项字段，在Excel中对应的列下，都必须有数据/值；',
          ],
        },
        footerList: [
          { slotName: 'uploadMain' },
          {
            text: '主订单模板下载',
            isShowBtn: true,
            click: () => {
              window.location.href = entLeaseOrderTemplate
            },
            options: {},
          },
          { slotName: 'uploadVice' },
          {
            text: '在租子订单模版下载',
            isShowBtn: true,
            click: () => {
              window.location.href = entLeaseSubOrderTemplate
            },
            options: {},
          },
          { slotName: 'uploadReturn' },
          {
            text: '已退子订单模版下载',
            isShowBtn: true,
            click: () => {
              window.location.href = entLeaseReutrnSubOrderTemplate
            },
            options: {},
          },
        ],
      }
    },

    paginationData() {
      return {
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        total: this.total,
        pageSizes: [10, 20, 30, 50],
      }
    },
  },
  mounted() {
    this.getTableData()

    // 动态计算表格宽度
    this.calcTableHeight()
    window.addEventListener('resize', () => {
      this.calcTableHeight()
    })
  },
  activated() {
    this.calcTableHeight()
  },
  methods: {
    /* 自定义上传 */
    uploadRequest(file, uploadType) {
      const formData = new FormData()
      formData.append('file', file)
      formData.append('group', 'order')
      formData.append('code', this.uploadCode[uploadType])
      axios({
        url: '/admin/v1/vehicle/fs/standard/upload',
        method: 'POST',
        data: formData,
        headers: {
          ...getHead(this.$store),
        },
      }).then(({ data: { code, data, msg } }) => {
        if (code === 1) {
          try {
            uploadTaskCreate({
              uploadType, // 37 企业租赁订单导入 38 企业租赁子订单导入 39 初始化退车子订单
              fileAddress: data,
              fileName: file.name,
            })
              .then((res) => {
                if (res.code === 1) {
                  this.$message({
                    message: '导入成功',
                    type: 'success',
                  })
                  this.$refs.batchImport.close()
                }
              })
              .catch((err) => { console.log('err', err) })
            this.fileList = []
          } catch (error) {
            this.fileList = []
          }
        } else {
          this.fileList = []
          this.$message.error(msg)
        }
      })
    },
    // 关闭导入弹窗
    closeBox() {
      // this.maintenanceUpload.boxShow = false
      this.uploadLoading = false
      this.importDataList = []
    },
    // 初始化历史企业租赁订单
    initOrder() {
      this.$refs.batchImport.showDialog()
    },
    // 点击跳转新增车辆页面
    handleAddCarClick(rowData) {
      this.$router.push({
        path: '/car_to_lease/forRentSignContract/enterSiginProcess',
        query: {
          stepActive: 1,
          entRentOrderId: rowData.id,
          customerId: rowData.customerId,
          customerName: rowData.customerName,
        },
      })
    },
    // 点击跳转订单续约
    handlerRecallClick(rowData) {
      this.$router.push({
        path: '/underLease/orderRenewal/enterpriseAdd',
        query: {
          stepActive: 1,
          orderId: rowData.id,
          orderType: 'enterprise',
          customerId: rowData.customerId,
          customerName: rowData.customerName,
        },
      })
    },
    // 点击id新开浏览器跳转详情页
    handleOrderIdClick(id) {
      const routeUrl = this.$router.resolve({
        name: 'workbench_ent_rent_order_main_detail',
        query: { id },
      })
      this.$router.push({
        path: routeUrl.href,
        query: { id },
      })
    },
    async getCustomerList(customerName) {
      const { code, data = [] } = await searchByCustomerName({
        customerState: 1,
        customerType: 2,
        customerName,
      })
      if (code === 1) {
        this.carProviderList = data
      }
    },

    // 分页器的事件
    async pageEvent({ pagination }) {
      this.BLMloading = true
      this.pageSize = pagination.pageSize
      this.pageNum = pagination.pageNum
      this.getTableData()
    },
    // 收集上传的数据
    getCollect() {
      const p = {
        ...this.params,
        state: this.state,
        dueState: this.dueState,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        createStartTime: this.params.startTime ? this.params.startTime[0] : '',
        createEndTime: this.params.startTime ? this.params.startTime[1] : '',
      }
      return p
    },

    // 搜索按钮
    getsearch: debounce(async function () {
      this.pageSize = 10
      this.pageNum = 1
      this.getTableData()
    }, 500),
    // 重置--清空表单项
    getreset() {
      this.pageSize = 10
      this.pageNum = 1
      // 使表单内容重新赋值为空字符串
      this.$refs.from_params.resetFields()
      this.getTableData()
    },
    // 新增采购单按钮点击事件
    addSigning() {
      this.$router.push({
        path: '/car_to_lease/forRentSignContract/enterSiginProcess',
        query: {
          stepActive: 0,
        },
      })
    },

    // 订单关闭
    getVoidComplete(item) {
      this.$confirm('请确认是否关闭订单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const { id } = item
        const res = await closeEnterpriseOrder({ id })
        if (res.code === 1) {
          this.$message({
            type: 'success',
            message: '关闭成功!',
          })
          this.getTableData()
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消',
        })
      })
    },
    // 请求数据table
    async getTableData() {
      this.BLMloading = true
      try {
        const { code, data } = await getLeaseOrderList(this.getCollect())
        if (code === 1) {
          this.tableData = data.items
          this.total = data.totalNum
        }
        this.BLMloading = false
      } catch (error) {
        console.log(error)
      }
      this.BLMloading = false
    },
    calcTableHeight() {
      this.$nextTick(() => {
        const offset = 455 // 除去表格其他元素总高度
        const computedHeight = window.innerHeight - this.$refs?.tableWrapper?.offsetTop - offset

        this.tableHeight = computedHeight < 248 ? 248 : computedHeight
      })
    },
    getSearchCondition() {
      const formConfig = [{
        el: 'input',
        itemConfig: {
          label: '企业租赁订单ID',
          prop: 'id',
        },
      }, {
        el: 'select',
        itemConfig: {
          label: '客户',
          prop: 'customerId',
        },
        elConfig: {
          options: {
            list: this.customerConditionList,
            value: 'id',
            label: 'customerName',
          },
        },
      }, {
        el: 'date-picker',
        itemConfig: {
          label: '订单创建时间',
          prop: 'startTime',
        },
      }, {
        el: 'select',
        itemConfig: {
          label: '所属部门',
          prop: 'deptIdList',
        },
        elConfig: {
          options: {
            list: this.$refs.deptSelectRef.flatOptions(),
            value: 'id',
            label: 'name',
          },
        },
      }]
      const condition = formConfig.map((item) => {
        const { el, itemConfig: { label, prop: key } } = item
        const val = this.params[key]
        const { matchValue, hidden } = generateExportCondition[el](val, item)
        return {
          label,
          key,
          matchValue,
          hidden,
        }
      })
      // 增加Tab查询条件
      condition.push({
        label: '订单类型',
        matchValue: '企业租赁订单',
      })
      return condition
    },
  },
}
</script>

<style lang="scss" scoped>
.leasecontract {
  ::v-deep .el-tabs__item {
    max-width: 140px;
    text-align: center;
  }

  .whole_contract_btn {
    &:nth-of-type(2) {
      color: #323233;
    }
  }

  .leasecontract_signing {
    margin: 16px 0;
  }

  .hand {
    user-select: none;

    span {
      cursor: pointer;
    }
  }
}
</style>
